import { addSongsToQueue } from 'spa/action_creators/player'
import { filterInt } from 'spa/shared/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { isMobileSelector } from '../../selectors/device'
import { NoRecordsLabel } from 'spa/components/no_records_label'
import { SongPropType } from 'spa/api/songs'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import SimpleSongsListItem2 from './simple_songs_list_item_2'
import styles from './styles'

export const SimpleSongsList2 = ({
  className,
  showArtist = true,
  showBorders,
  showNumbers,
  songs,
  queuedSongIds,
  variant,
  addSongToQueue,
  removeSongFromQueue,
  trackList,
  fixedPopover = false,
  showPagination,
  showPopularity,
}) => {
  const dispatch = useDispatch()
  const { autoplay } = useSelector(state => state.userPreferences)
  const { currentSongId } = useSelector(state => state.player)
  const isMobile = useSelector(isMobileSelector)
  const initialPageSize = showPagination ? 5 : songs?.length

  const [toggledSongId, setToggledSongId] = useState(null)
  const [pageSize, setPageSize] = useState(initialPageSize)

  const toggleVersionsList = song => openSongId =>
    setToggledSongId(
      openSongId === undefined || typeof openSongId === 'object'
        ? parseInt(toggledSongId) === parseInt(song.rid)
          ? null
          : song.rid
        : openSongId
    )

  const handleClickBubble = e => {
    const { listIndex } = e.target.dataset
    const songIndex = filterInt(listIndex)
    if (
      autoplay &&
      typeof songIndex === 'number' &&
      songs[songIndex] &&
      parseInt(currentSongId) !== parseInt(songs[songIndex].rid)
    ) {
      if (songs.length) dispatch(addSongsToQueue(songs))
    }
  }
  return (
    <>
      <div onClick={handleClickBubble}>
        <ul className={classNames(styles.simpleSongsList, className)}>
          {/* Head */}
          {!isMobile ? (
            <tr className={classNames(styles.head)}>
              <td colSpan={2}>
                <FormattedMessage
                  defaultMessage="RECORDS"
                  id="djcity.records.recordpool.track.records"
                />
              </td>
              <td>
                <FormattedMessage
                  defaultMessage="Genre"
                  id="djcity.records.recordpool.track.genre"
                />
              </td>
              <td>
                <FormattedMessage
                  defaultMessage="BPM"
                  id="djcity.records.recordpool.track.bpm"
                />
              </td>
              <td>
                <FormattedHTMLMessage
                  defaultMessage="Popularity"
                  id="djcity.common.popularity.label"
                />
              </td>
              <td>
                <FormattedMessage
                  defaultMessage="Versions"
                  id="djcity.records.recordpool.track.versions"
                />
              </td>
              <td></td>
            </tr>
          ) : null}
          {songs.length === 0 ? (
            <tr>
              <td colSpan={9}>
                <NoRecordsLabel />
              </td>
            </tr>
          ) : (
            songs
              .slice(0, pageSize)
              .map((song, index) => (
                <SimpleSongsListItem2
                  addSongToQueue={addSongToQueue}
                  currentlyInQueue={
                    queuedSongIds
                      ? queuedSongIds.includes(parseInt(song.rid))
                      : false
                  }
                  fixedPopover={fixedPopover}
                  index={showNumbers ? index + 1 : undefined}
                  key={song.rid}
                  listIndex={index}
                  removeSongFromQueue={removeSongFromQueue}
                  separator={index !== Math.min(songs.length, pageSize) - 1}
                  showArtist={showArtist}
                  showBorder={showBorders}
                  showPopularity={showPopularity}
                  showVersionsList={
                    parseInt(toggledSongId) === parseInt(song.rid)
                  }
                  song={song}
                  toggleVersionsList={toggleVersionsList(song)}
                  trackList={trackList}
                  variant={variant}
                />
              ))
          )}
        </ul>
      </div>
      {pageSize < songs.length ? (
        <div className={styles.seemore}>
          <button
            className={classNames('cleanButton')}
            onClick={() => setPageSize(pageSize + initialPageSize)}
          >
            <FontAwesomeIcon icon="plus" />
            <FormattedMessage
              defaultMessage="SEE MORE"
              id="djcity.common.seemore"
            />
          </button>
        </div>
      ) : null}
    </>
  )
}

SimpleSongsList2.propTypes = {
  addSongToQueue: PropTypes.func,
  className: PropTypes.string,
  fixedPopover: PropTypes.bool,
  queuedSongIds: PropTypes.arrayOf(PropTypes.number),
  removeSongFromQueue: PropTypes.func,
  showArtist: PropTypes.bool,
  showBorders: PropTypes.bool,
  showNumbers: PropTypes.bool,
  showPagination: PropTypes.bool,
  showPopularity: PropTypes.bool,
  songs: PropTypes.arrayOf(SongPropType),
  trackList: PropTypes.string,
  variant: PropTypes.oneOf(['light', 'dark']),
}
